import './App.css';
import { Home } from './components/Home/Home';
import { Landing } from './components/Landing/Landing';
import { GoBack } from './components/GoBack/GoBack';
import { Alumnos } from './components/Alumnos/Alumnos';
import { FotosGrupales } from './components/FotosGrupales/FotosGrupales';
import { LineasInvestigacion } from './components/LineasInvestigacion/LineasInvestigacion';
import { Blog } from './components/Blog/Blog';
import { EventosFinales } from './components/EventosFinales/EventosFinales';
import { EventosProximos } from './components/EventosProximos/EventosProximos';
import { Contacto } from './components/Contacto/Contacto';
import { Publicaciones } from './components/Publicaciones/Publicaciones';
import { Login } from './pages/Login';
import { ProfileEdit } from './pages/ProfileEdit';
import { Dashboard } from './pages/Dashboard';
import { StudentsList } from './Dashboard/StudentsList';
import { GroupPhotosList } from './Dashboard/GroupPhotosList';
import { BlogsList } from './Dashboard/BlogsList';
import { EventsList } from './Dashboard/EventsList';
import { ProjectTypesList } from './Dashboard/ProyectTypesList';
import { PapersList } from './Dashboard/PapersList';
import { PatentsList } from './Dashboard/PatentsList';
import { CollaboratorsList } from './Dashboard/CollaboratorsList';
import { TesisList } from './Dashboard/TesisList';
import { TesisTypesList } from './Dashboard/TesisTypesList';
import { TesisCategoriesList } from './Dashboard/TesisCategoriesList';
import { ResearchLinesList } from './Dashboard/ResearchLinesList';
import { SubLinesList } from './Dashboard/SubLinesList';
import { MigrateResearchLines } from './Dashboard/MigrateResearchLines';
import { LineaInvestigacion } from './pages/LineaInvestigacion';
import { Student } from './pages/Student';
import { Colaboradores } from './components/Colaboradores/Colaboradores';
import { Graduados } from './components/Graduados/Graduados';
import { TodasLasEntradas } from './components/TodasLasEntradas/TodasLasEntradas';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Proyectos } from './components/Proyectos/Proyectos';
import VisitCounter from './components/VisitCounter/VisitCounter';
import { useEffect, useRef, useState } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import Post from './pages/Post';
import { getDocs, collection, query, where, orderBy, doc, getDoc } from 'firebase/firestore/lite';
import {auth, db} from './firebase';

const MainPage = (props) => {

  window.scrollTo(0,0);

  return(
    <>
      <Landing> </Landing>  
      <Home {...props}></Home>
      <Proyectos></Proyectos>
      <Publicaciones {...props}></Publicaciones>
      <Alumnos {...props}></Alumnos>
      <FotosGrupales {...props}></FotosGrupales>
      <LineasInvestigacion {...props}></LineasInvestigacion>
      <Colaboradores {...props}/>
      <EventosProximos {...props} ></EventosProximos>
      <EventosFinales {...props}></EventosFinales>
      <Blog {...props}></Blog>
      <Graduados {...props}/>
      <Contacto></Contacto>
      <GoBack href='#Landing'/>
    </>
  )
}

/** Vista alternativa de la página principal (comparar con otra rama). Contenido editable para reflejar alternative_branch. */
const AlternativeMainPage = (props) => {
  window.scrollTo(0,0);
  return (
    <>
      <Landing />
      <Home {...props} />
      <Proyectos />
      <Publicaciones {...props} />
      <Alumnos {...props} />
      <FotosGrupales {...props} />
      <LineasInvestigacion {...props} />
      <Colaboradores {...props} />
      <EventosProximos {...props} />
      <EventosFinales {...props} />
      <Blog {...props} />
      <Graduados {...props} />
      <Contacto />
      <GoBack href="#Landing" />
    </>
  )
}

// main | alternative (see .env REACT_APP_VIEW_MODE)
const useMainView = process.env.REACT_APP_VIEW_MODE !== 'alternative'
const MainPageComponent = useMainView ? MainPage : AlternativeMainPage

function App() {

  const [students, setStudents] = useState([]);
  const [photos, setPhotos] = useState([]);
  const [blogs, setBlogs] = useState([]);
  const [events, setEvents] = useState([]);
  const [projectTypes, setProjectTypes] = useState([]);
  const [papers, setPapers] = useState([]);
  const [patents, setPatents] = useState([]);
  const [collaborators, setCollaborators] = useState([]);
  const [tesis, setTesis] = useState([]);
  const [profile, setProfile] = useState([]);
  const [tesisTypes, setTesisTypes] = useState([]);
  const [tesisCategories, setTesisCategories] = useState([]);
  const [researchLines, setResearchLines] = useState([]);
  const [subLines, setSubLines] = useState([]);

  const fetchStudents = async () => {
    try {
      const q = query(collection(db, "students"), where("habilitado", "==", true), orderBy('orden'));
      const querySnapshot = await getDocs(q);
      const newData = querySnapshot.docs
        .map((doc) => ({ ...doc.data(), id:doc.id }));
      setStudents(newData);
    } catch (error) {
      console.error('Error fetching students:', error);
      setStudents([]);
    }
  }

  const fetchGroupPhotos = async () => {
    try {
      const q = query(collection(db, 'group-photos'), where("enabled", "==", true), orderBy('order'));
      const querySnapshot = await getDocs(q);
      const newData = querySnapshot.docs
        .map((doc) => ({ ...doc.data(), id:doc.id }));
      setPhotos(newData);
    } catch (error) {
      console.error('Error fetching group photos:', error);
      setPhotos([]);
    }
  }

  const fetchBlogs = async () => {
    try {
      const q = query(collection(db, 'blogs'), where("enabled", "==", true), orderBy('order'));
      const querySnapshot = await getDocs(q);
      const newData = querySnapshot.docs
        .map((doc) => ({ ...doc.data(), id:doc.id }));
      setBlogs(newData);
    } catch (error) {
      console.error('Error fetching blogs:', error);
      setBlogs([]);
    }
  }

  const fetchEvents = async () => {
    try {
      const q = query(collection(db, 'events'), where("enabled", "==", true), orderBy('order'));
      const querySnapshot = await getDocs(q);
      const newData = querySnapshot.docs
        .map((doc) => ({ ...doc.data(), id:doc.id }));
      setEvents(newData);
    } catch (error) {
      console.error('Error fetching events:', error);
      setEvents([]);
    }
  }

  const fetchProjectTypes = async () => {
    try {
      const q = query(collection(db, 'project-types'), where("enabled", "==", true), orderBy('order'));
      const querySnapshot = await getDocs(q);
      const newData = querySnapshot.docs
        .map((doc) => ({ ...doc.data(), id:doc.id }));
      setProjectTypes(newData);
    } catch (error) {
      console.error('Error fetching project types:', error);
      setProjectTypes([]);
    }
  }

  const fetchPapers = async () => {
    try {
      const q = query(collection(db, 'papers'), where("enabled", "==", true), orderBy('year'));
      const querySnapshot = await getDocs(q);
      let papersList = { "years" : [], "byYear": {} };
      querySnapshot.docs
        .forEach((qDoc) => {
          const doc = { ...qDoc.data(), id:qDoc.id };
          if ( !papersList.byYear[doc.year] )
          {
            papersList.years.push(doc.year);
            papersList.byYear[doc.year] = [];
          }
          papersList.byYear[doc.year].push(doc);
        });
      papersList.years.reverse();
      setPapers(papersList);
    } catch (error) {
      console.error('Error fetching papers:', error);
      setPapers({ "years" : [], "byYear": {} });
    }
  }

  const fetchPatents = async () => {
    try {
      const q = query(collection(db, 'patents'), where("enabled", "==", true), orderBy('order'));
      const querySnapshot = await getDocs(q);
      const newData = querySnapshot.docs
        .map((doc) => ({ ...doc.data(), id:doc.id }));
      setPatents(newData);
    } catch (error) {
      console.error('Error fetching patents:', error);
      setPatents([]);
    }
  }

  const fetchCollaborators = async () => {
    try {
      const q = query(collection(db, 'collaborators'), where("enabled", "==", true), orderBy('order'));
      const querySnapshot = await getDocs(q);
      const newData = querySnapshot.docs
        .map((doc) => ({ ...doc.data(), id:doc.id }));
      setCollaborators(newData);
    } catch (error) {
      console.error('Error fetching collaborators:', error);
      setCollaborators([]);
    }
  }

  const fetchTesis = async () => {
    try {
      const q = query(collection(db, 'tesis'), where("enabled", "==", true), orderBy('order'));
      const querySnapshot = await getDocs(q);
      let tesisList = {};
      querySnapshot.docs
        .forEach((qDoc) => {
          const doc = { ...qDoc.data(), id:qDoc.id };
          if ( !tesisList[doc.type] )
          {
            tesisList[doc.type] = {}
          }
          if (!tesisList[doc.type][doc.category])
          {
            tesisList[doc.type][doc.category] = [];
          }
          tesisList[doc.type][doc.category].push(doc);
        });
      setTesis(tesisList);
    } catch (error) {
      console.error('Error fetching tesis:', error);
      setTesis({});
    }
  }

  const fetchTesisTypes = async () => {
    try {
      const q = query(collection(db, 'tesis-types'), where("enabled", "==", true), orderBy('order'));
      const querySnapshot = await getDocs(q);
      const newData = querySnapshot.docs
        .map((doc) => ({ ...doc.data(), id:doc.id }));
      setTesisTypes(newData);
    } catch (error) {
      console.error('Error fetching tesis types:', error);
      setTesisTypes([]);
    }
  }

  const fetchTesisCategories = async () => {
    try {
      const q = query(collection(db, 'tesis-categories'), where("enabled", "==", true), orderBy('order'));
      const querySnapshot = await getDocs(q);
      const newData = querySnapshot.docs
        .map((doc) => ({ ...doc.data(), id:doc.id }));
      setTesisCategories(newData);
    } catch (error) {
      console.error('Error fetching tesis categories:', error);
      setTesisCategories([]);
    }
  }

  const fetchProfile = async () => {
    try {
      const docSnap = await getDoc(doc(db, "profile", "4fTlePDeB9cdfxkw2okC"));
      if (docSnap.exists()) {
        setProfile(docSnap.data());
      } else {
        console.warn('Profile document does not exist');
        setProfile({});
      }
    } catch (error) {
      console.error('Error fetching profile:', error);
      setProfile({});
    }
  }

  const fetchResearchLines = async () => {
    try {
      const q = query(collection(db, "research-lines"), orderBy('order'));
      const querySnapshot = await getDocs(q);
      const newData = querySnapshot.docs
        .map((doc) => ({ ...doc.data(), id:doc.id }))
        .filter(line => line.enabled !== false);
      setResearchLines(newData);
    } catch (error) {
      console.error('Error fetching research lines:', error);
      setResearchLines([]);
    }
  }

  const fetchSubLines = async () => {
    try {
      const q = query(collection(db, "sub-research-lines"), orderBy('orden'));
      const querySnapshot = await getDocs(q);
      const newData = querySnapshot.docs
        .map((doc) => ({ ...doc.data(), id:doc.id }))
        .filter(subLine => subLine.enabled !== false);
      setSubLines(newData);
    } catch (error) {
      console.error('Error fetching sub-lines:', error);
      setSubLines([]);
    }
  }

  useEffect(()=>{
    fetchStudents();
    fetchGroupPhotos();
    fetchBlogs();
    fetchEvents();
    fetchProjectTypes();
    fetchPapers();
    fetchPatents();
    fetchProfile();
    fetchCollaborators();
    fetchTesis();
    fetchTesisCategories();
    fetchTesisTypes();
    fetchResearchLines();
    fetchSubLines();             
  }, [])



  const [user, setUser] = useState(null);

  const [, setVisits] = useState(0)
  const shoullog = useRef(true)
  useEffect(()=>{
    if( shoullog.current ){
      shoullog.current = false;
      // Update visit counter with timeout to prevent hanging
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 5000); // 5 second timeout
      
      fetch('https://api.countapi.xyz/update/rlucioporto/webpage/?amount=1', {
        signal: controller.signal
      })
      .then(res => {
        clearTimeout(timeoutId);
        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }
        return res.json();
      })
      .then(res => {
        if (res.value !== undefined) {
          setVisits(res.value);
          // Store in localStorage as backup
          localStorage.setItem('visitCount', res.value.toString());
        }
      })
      .catch( error => {
        clearTimeout(timeoutId);
        if (error.name === 'AbortError') {
          console.warn('Visit counter request timed out');
        } else {
          console.error('Error updating visit counter:', error);
        }
        // Fallback to localStorage if available
        const storedCount = localStorage.getItem('visitCount');
        if (storedCount) {
          setVisits(parseInt(storedCount, 10));
        }
        // Silently fail - visit counter is not critical
      });
    }
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    }, (error) => {
      console.error('Error in auth state change:', error);
    });
    return () => unsubscribe();

  },[])

  const Element = <MainPageComponent profile={profile} tesisCategories={tesisCategories} tesisTypes={tesisTypes} tesis={tesis} collaborators={collaborators} patents={patents} papers={papers} projectTypes={projectTypes} students={students} photos={photos} events={events} blogs={blogs} researchLines={researchLines} subLines={subLines} />;

  return (
    <BrowserRouter>
      <Routes >
        <Route path='/' element={Element} ></Route>
        <Route path='/login' element={<Login/>} ></Route> 
        <Route path='/Linea/:name' element={<LineaInvestigacion projectTypes={projectTypes} students={students} researchLines={researchLines} subLines={subLines} />}></Route>
        <Route path='/Student/:studentId' element={<Student projectTypes={projectTypes} students={students} researchLines={researchLines} subResearchLines={subLines} />}></Route>
        <Route path='/Blog/:id' element={<Post blogs={blogs}/>}></Route>
        <Route path='/visit' element={<VisitCounter/>}></Route>
        <Route path='/Entradas'  element={<TodasLasEntradas/>}></Route>
        <Route path='*' element={ <h1> NOT FOUND </h1> }></Route>
        <Route
          path="/dashboard"
          element={user ? <Dashboard /> : Element}
        />
        <Route
          path="/students"
          element={user ? <StudentsList projectTypes={projectTypes}/> : Element}
        />
        <Route
          path="/group-photos"
          element={user ? <GroupPhotosList /> : Element}
        />
        <Route
          path="/blogs"
          element={user ? <BlogsList /> : Element}
        />
        <Route
          path="/events"
          element={user ? <EventsList /> : Element}
        />
        <Route
          path="/project-types"
          element={user ? <ProjectTypesList /> : Element}
        />
        <Route
          path="/papers"
          element={user ? <PapersList /> : <MainPage />}
        />
        <Route
          path="/patents"
          element={user ? <PatentsList /> : Element}
        />
        <Route
          path="/collaborators"
          element={user ? <CollaboratorsList /> : <MainPage />}
        />
        <Route
          path="/tesis"
          element={user ? <TesisList /> : Element}
        />
        <Route
          path="/tesis-types"
          element={user ? <TesisTypesList /> : Element}
        />
        <Route
          path="/tesis-categories"
          element={user ? <TesisCategoriesList /> : Element}
        />
        <Route
          path="/research-lines"
          element={user ? <ResearchLinesList /> : <MainPage />}
        />
        <Route
          path="/sub-lines"
          element={user ? <SubLinesList /> : Element}
        />
        <Route
          path="/migrate-research-lines"
          element={user && user.email === 'raulizqli@gmail.com' ? <MigrateResearchLines /> : <MainPage />}
        />
        <Route
          path="/profile"
          element={user ? <ProfileEdit /> : Element}
        />
      </Routes>
    </BrowserRouter>
    
  );
}



export default App;
